module.exports = __webpack_public_path__ + "img/barbarian.d66c6649.png";